import { StripeMobilePayView } from './stripe-mobile-pay-view';
import { Translations } from '../config/translations';

export class StripeGooglePayView extends StripeMobilePayView {

    constructor() {
        super();
    }

    getPaymentRequestButtonElement() {
        return `<fieldset class='form-columns-1 df-payment-field df-fieldset'>
                    <input type='button'
                        id='stripe_payment_request_button'
                        class='stripe-google-pay hs-button primary large df-input'
                        data-label="pay_now"
                        value='${Translations.PAY_NOW}'
                    />
                </fieldset>`;
    }

}
